<template>
  <div class="w-full max-w-[130px] lg:max-w-[187px] mb-10">
    <button @click="addLineItem"
            class="w-full hover:bg-[#018bdf] transition block border border-black bg-blue rounded-full pt-[100%] relative ">
      <div
          class="font-title absolute text-center top-0 left-0 w-full h-full flex items-center justify-center  text-[28px] lg:text-[33px] leading-[1.03] uppercase">
        Buy now
      </div>
    </button>
  </div>
</template>

<script setup>
import Client from 'shopify-buy';
import { ref, onMounted, watch } from 'vue';
import { inject } from 'vue'

const lineItems = ref(null);
const checkoutUrl = ref(null);
console.log('in cart');

const client = Client.buildClient({
  domain: "camden-arts-projects.myshopify.com",
  storefrontAccessToken: "c235a42ed21a271b8785f6a5170145a5",
});


const props = defineProps({
  variant: {
    type: String
  }
});


// const checkoutId = 'gid://shopify/Checkout/2f09adb9dcfedbb0d28f7a8f2903dc11?key=2cca215f6381f4b55bcae9449c72776b'
const loading = ref(false);

let formatCurrency = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP'
});

const emitter = inject('emitter'); // Inject `emitter`

onMounted(() => {
  console.log('mounted');
  console.log(props.variant);

});


const addLineItem = () => {

  emitter.emit('addToCart', {
    variant: props.variant
  });

}
</script>